import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/selling-on-multiple-marketplaces';

export default function Example() {
  return (
    <>
      <Head>
        <title>Selling on Multiple Marketplaces: Is It Worth It?</title>
        <meta
          name='description'
          content='Managing a reselling business on a single online platform is already a challenge. Is it worth it to do it on different marketplaces too?'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/selling-on-multiple-marketplaces' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/selling-on-multiple-marketplaces' />
        <meta property='og:title' content='Selling on Multiple Marketplaces: Is It Worth It?' />
        <meta
          property='og:description'
          content='Managing a reselling business on a single online platform is already a challenge. Is it worth it to do it on different marketplaces too?'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-08-19T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-08-19T00:00:00-00:00' />
        <meta property='article:tag' content='-' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
